const moment = require('moment');
const { validateEmail, validatePhoneNumber } = require('./validators');
const { errormsg } = require('./constants');

const requiredInput = {
  required: true,
  trigger: 'blur',
  message: errormsg.input_option
};

const requiredSelect = {
  required: true,
  trigger: 'change',
  message: errormsg.select_option
};

const nonRequired = {
  required: false,
  trigger: 'blur',
  message: errormsg.input_option
};

const checkBirthdate = (rule, value, cb) => {
  if (rule.required && !value) return cb(new Error('DOB is required'));
  if (value && !moment(value, moment.ISO_8601, true).isValid()) return cb(new Error('Invalid birth date'));
  return cb();
};
const checkEmail = (rule, value, cb) => {
  if (rule.required && !value) return cb(new Error('Email is required'));
  if (value && !validateEmail(value)) return cb(new Error('Invalid email'));
  return cb();
};
const checkMobile = (rule, value, cb) => {
  if (rule.required && !value) return cb(new Error('Mobile is required'));
  if (value && !validatePhoneNumber(value)) return cb(new Error('Invalid mobile'));
  return cb();
};

/**
 * Parse google address to our address format
 * @param {Object} addressData: vue2-google-maps addressData
 * @param {Object} place: google api original place result
 */
const parseGoogleAddress = (addressData, place) => {
  const address = {
    formatted: place.formatted_address,
    lat: addressData.latitude,
    lng: addressData.longitude,
    addressLine1: (addressData.street_number ? (`${addressData.street_number} `) : '') + addressData.route,
    addressLine2: '',
    suburb: addressData.locality,
    state: addressData.administrative_area_level_1,
    postcode: addressData.postal_code,
    country: addressData.country,
  };
  return address;
};

/**
 * Calculate age
 * @param {string} dob: birthdate
 * @param {string} endOfYear: YYYY-MM-DD
 * @param {string} [format]: birthdate format, default: YYYY-MM-DD
 */
const calculateMemberAge = (dob, endOfYear, format = 'YYYY-MM-DD') => {
  const birth = moment(dob, format);
  if (endOfYear) {
    const current = moment(endOfYear, 'YYYY-MM-DD');
    return current.diff(birth, 'years');
  }
  return moment().diff(birth, 'years');
};

/**
 * Create a file and download
 * @param {string} fileName
 * @param {string} fileType
 * @param {string} data
 * @param {string} type
 */
const createAndDownload = (fileName, fileType, data, type) => {
  const b = new Blob([data], { type });
  const url = URL.createObjectURL(b);

  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.${fileType}`;
  a.style = 'display: none';
  document.body.appendChild(a);

  a.click();
  URL.revokeObjectURL(url);
};

function generateHexString(length = 20) {
  let ret = '';
  while (ret.length < length) {
    ret += Math.random().toString(16).substring(2);
  }
  return ret.substring(0, length);
}
function urlify(text) {
  // eslint-disable-next-line no-var
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, '<a target="_blank" href="$1">$1</a>');
}

/**
 * Increments is an array, example increment by 2 and 5 is [2, 5]. Empty means increment by 1
 * @param {int} from
 * @param {int} to
 * @param {array} increments
 */
function computeIncrements(from, to, increments = []) {
  const arr = [];
  let hasIncrement = false;
  if (increments.length > 0) {
    hasIncrement = true;
  }
  for (let i = from; i <= to; i++) {
    if (hasIncrement) {
      if (i === 0) {
        arr.push(i);
      }
      for (let inc = 0; inc < increments.length; inc++) {
        if (i % increments[inc] === 0 && i > 0) {
          arr.push(i);
        }
      }
    } else {
      arr.push(i);
    }
  }
  return arr;
}

/**
 * Parse birthdate DD/MM/YYYY -> YYYY-MM-DD
 * @param {string} val: birthdate
 */
const parseBirthdate = (val, reverse = false) => {
  if (reverse) return moment(val, 'YYYY-MM-DD').format('DD/MM/YYYY');
  return moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
};

module.exports = {
  parseGoogleAddress,
  requiredInput,
  requiredSelect,
  checkBirthdate,
  checkEmail,
  checkMobile,
  calculateMemberAge,
  createAndDownload,
  generateHexString,
  urlify,
  computeIncrements,
  nonRequired,
  parseBirthdate
};
